<script>
  export let title = "Hierarchy";
  export let open = false;
  export let topOffset = "4rem";
  export let width = "24rem";

  function toggleOpen() {
    open = !open;
  }
</script>

<aside
  class="left_overlay_drawer"
  style={`--drawer-top: ${topOffset}; --drawer-width: ${width};`}
>
  {#if open}
    <div class="drawer_panel">
      <div class="drawer_content">
        <slot />
      </div>
    </div>
  {/if}

  <div class="drawer_rail">
    <button
      type="button"
      class="drawer_toggle drawer_toggle_top"
      aria-label={open ? `Collapse ${title}` : `Expand ${title}`}
      title={open ? `Collapse ${title}` : `Expand ${title}`}
      on:click={toggleOpen}
    >
      <img src={open ? "/img/assistant/icons/chevron_left_dark.svg" : "/img/assistant/icons/chevron_right_dark.svg"} alt="" />
    </button>
    <button
      type="button"
      class="drawer_label"
      aria-label={open ? `Collapse ${title}` : `Expand ${title}`}
      title={open ? `Collapse ${title}` : `Expand ${title}`}
      on:click={toggleOpen}
    >
      <span>{title}</span>
    </button>
    <button
      type="button"
      class="drawer_toggle drawer_toggle_bottom"
      aria-label={open ? `Collapse ${title}` : `Expand ${title}`}
      title={open ? `Collapse ${title}` : `Expand ${title}`}
      on:click={toggleOpen}
    >
      <img src={open ? "/img/assistant/icons/chevron_left_dark.svg" : "/img/assistant/icons/chevron_right_dark.svg"} alt="" />
    </button>
  </div>
</aside>

<style>
  .left_overlay_drawer {
    position: fixed;
    top: var(--drawer-top);
    left: var(--app-side-nav-width, 4rem);
    z-index: 35;
    height: calc(100vh - var(--drawer-top));
    display: flex;
    pointer-events: none;
  }

  .drawer_panel {
    width: var(--drawer-width);
    max-width: min(var(--drawer-width), calc(100vw - var(--app-side-nav-width, 4rem) - 3rem));
    height: 100%;
    box-sizing: border-box;
    display: flex;
    flex-direction: column;
    border-right: 1px solid #c9c9c9;
    background: var(--pax-white);
    color: var(--pax-black);
    pointer-events: auto;
    box-shadow: 0.25rem 0 0.75rem rgba(0, 0, 0, 0.06);
  }

  .drawer_rail button {
    border: 0;
    background: var(--pax-white);
    color: var(--pax-black);
    cursor: pointer;
  }

  .drawer_content {
    min-height: 0;
    flex: 1;
    overflow-y: auto;
    padding: 1rem;
    background: var(--pax-white);
  }

  .drawer_rail {
    width: 2.25rem;
    height: 100%;
    display: flex;
    align-items: center;
    flex-direction: column;
    border-right: 1px solid #c9c9c9;
    background: var(--pax-white);
    pointer-events: auto;
  }

  .drawer_toggle {
    width: 2rem;
    height: 2rem;
    flex: 0 0 2rem;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: 0.55rem;
    border-radius: var(--br);
  }

  .drawer_toggle_bottom {
    margin-top: 0;
    margin-bottom: 0.55rem;
  }

  .drawer_toggle img {
    width: 1rem;
    height: 1rem;
  }

  .drawer_label {
    width: 100%;
    min-height: 0;
    flex: 1;
    display: flex;
    align-items: center;
    justify-content: center;
    padding: 0;
  }

  .drawer_label span {
    writing-mode: vertical-rl;
    transform: rotate(180deg);
    font-size: 0.82rem;
    letter-spacing: 0;
  }
</style>
